module.exports = "<div [ngStyle]=\"locationCss\" class=\"container\">\n    <form>\n        <label for=\"filterInput\"> Filter value:</label>\n        <input #input name=\"filterInput\" type=\"text\" [(ngModel)]=\"filter\" (change)=\"onFilterChanged($event)\"/>\n        <br/>\n        <div class=\"pull-right buttons\">\n            <button (click)=\"onOk($event)\">Ok</button>\n            <button (click)=\"onClear($event)\">Clear</button>\n            <button (click)=\"onCancel($event)\">Cancel</button>\n        </div>\n    </form>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/filter.component.html
// module id = 485
// module chunks = 1